import React from 'react'
import Section from './Section'
import { MechanicalPageNumber } from '../../constants'

export default ({ calculateViewChange, navigatePageWithState, offer, urlState, prospectDocuments, canEdit }) => {
  const documents = prospectDocuments && prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.startsWith('qmeter'))
  const paintMeterQuestions = documents && documents.items
  const offerPaintMeter = offer && offer.prospect.paintMeter
  const urlPaintMeter = paintMeterQuestions && urlState.qmeter && urlState.qmeter.v && urlState.qmeter.v.length && paintMeterQuestions.map(q => ({ ...q, value: urlState.qmeter.v.find(answer => answer.questionId === q.questionId).value }))

  const paintMeter = (urlPaintMeter || (urlPaintMeter === undefined && offerPaintMeter) || [])
    .map(x => {
      return { questionId: x.questionId, value: x.value, order: x.label.split('|')[0], label: x.label.split('|')[1] }
    })
    .sort((a, b) => a.order - b.order)

  const anyAnswered = paintMeter && !!paintMeter.filter(r => r && !!r.value).length

  const loaded = !!paintMeterQuestions
  let uniqueViewStr = 'uniqueViewStr:'
  const component = (
    <Section title={'Paint Meter Readings'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: MechanicalPageNumber })}>
      {anyAnswered &&
        paintMeter
          .sort((first, second) => first.label.split('|')[0] > second.label.split('|')[0])
          .map((question, index) => {
            uniqueViewStr += question.label + question.value
            return (
              <div key={index}>
                <span>{question.label}:</span> {question.value}
              </div>
            )
          })}
    </Section>
  )
  calculateViewChange('paintMeter', loaded && uniqueViewStr)
  return component
}
